// ============================================================
// Braval - Filters Sidebar Component
// ============================================================

import React from 'react';

export default function FiltersSidebar({ filters, setFilters, onSearch }) {

    const handleChange = (field, value) => {
        setFilters(prev => ({ ...prev, [field]: value }));
    };

    const handleClear = () => {
        setFilters({
            projectName: '',
            auctioneer: '',
            dataSource: '',
            auctionYearFrom: '',
            auctionYearTo: '',
            itemYearFrom: '',
            itemYearTo: '',
            includeNullItemYear: false,
            make: '',
            priceMin: '',
            priceMax: '',
        });
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') onSearch();
    };

    return (
        <div>
            <div className="filters-title">Filters</div>

            {/* Project Name */}
            <div className="filter-group">
                <label className="filter-label">Project Name</label>
                <input
                    type="text"
                    className="filter-input"
                    placeholder="e.g. Jabil"
                    value={filters.projectName}
                    onChange={(e) => handleChange('projectName', e.target.value)}
                    onKeyDown={handleKeyDown}
                />
            </div>

            {/* Auctioneer */}
            <div className="filter-group">
                <label className="filter-label">Auctioneer</label>
                <input
                    type="text"
                    className="filter-input"
                    placeholder="e.g. TBG"
                    value={filters.auctioneer}
                    onChange={(e) => handleChange('auctioneer', e.target.value)}
                    onKeyDown={handleKeyDown}
                />
            </div>

            {/* Data Source */}
            <div className="filter-group">
                <label className="filter-label">Data Source</label>
                <select
                    className="filter-input"
                    value={filters.dataSource}
                    onChange={(e) => handleChange('dataSource', e.target.value)}
                >
                    <option value="">All</option>
                    <option value="Comps-Classic">Comps-Classic</option>
                    <option value="Observed">Observed</option>
                    <option value="TBG Bidspotter">TBG Bidspotter</option>
                    <option value="TBG Classic">TBG Classic</option>
                </select>
            </div>

            {/* Make / Manufacturer */}
            <div className="filter-group">
                <label className="filter-label">Make / Manufacturer</label>
                <input
                    type="text"
                    className="filter-input"
                    placeholder="e.g. Trumpf"
                    value={filters.make}
                    onChange={(e) => handleChange('make', e.target.value)}
                    onKeyDown={handleKeyDown}
                />
            </div>

            {/* Auction Year Range */}
            <div className="filter-group">
                <label className="filter-label">Auction Year</label>
                <div className="filter-range">
                    <input
                        type="number"
                        className="filter-input filter-input-half"
                        placeholder="From"
                        value={filters.auctionYearFrom}
                        onChange={(e) => handleChange('auctionYearFrom', e.target.value)}
                        onKeyDown={handleKeyDown}
                        min="1900"
                        max="2100"
                    />
                    <span className="filter-range-sep">–</span>
                    <input
                        type="number"
                        className="filter-input filter-input-half"
                        placeholder="To"
                        value={filters.auctionYearTo}
                        onChange={(e) => handleChange('auctionYearTo', e.target.value)}
                        onKeyDown={handleKeyDown}
                        min="1900"
                        max="2100"
                    />
                </div>
            </div>

            {/* Item Year Range */}
            <div className="filter-group">
                <label className="filter-label">Item Year (Manufacture)</label>
                <div className="filter-range">
                    <input
                        type="number"
                        className="filter-input filter-input-half"
                        placeholder="From"
                        value={filters.itemYearFrom}
                        onChange={(e) => handleChange('itemYearFrom', e.target.value)}
                        onKeyDown={handleKeyDown}
                        min="1900"
                        max="2100"
                    />
                    <span className="filter-range-sep">–</span>
                    <input
                        type="number"
                        className="filter-input filter-input-half"
                        placeholder="To"
                        value={filters.itemYearTo}
                        onChange={(e) => handleChange('itemYearTo', e.target.value)}
                        onKeyDown={handleKeyDown}
                        min="1900"
                        max="2100"
                    />
                </div>
                <label className="filter-checkbox-label">
                    <input
                        type="checkbox"
                        checked={filters.includeNullItemYear}
                        onChange={(e) => handleChange('includeNullItemYear', e.target.checked)}
                    />
                    Include items with unknown year
                </label>
            </div>

            {/* Sale Price Range */}
            <div className="filter-group">
                <label className="filter-label">Sale Price</label>
                <div className="filter-range">
                    <input
                        type="number"
                        className="filter-input filter-input-half"
                        placeholder="Min $"
                        value={filters.priceMin}
                        onChange={(e) => handleChange('priceMin', e.target.value)}
                        onKeyDown={handleKeyDown}
                        min="0"
                    />
                    <span className="filter-range-sep">–</span>
                    <input
                        type="number"
                        className="filter-input filter-input-half"
                        placeholder="Max $"
                        value={filters.priceMax}
                        onChange={(e) => handleChange('priceMax', e.target.value)}
                        onKeyDown={handleKeyDown}
                        min="0"
                    />
                </div>
            </div>

            <button class="filter-search-button" onClick={onSearch}>
                Apply Filters
            </button>
            <button class="filter-clear-button" onClick={handleClear}>
                Clear Filters
            </button>
        </div>
    );
}